import PageLayout from "@/components/site/PageLayout";
import PageHeader from "@/components/site/PageHeader";
import WhyChooseUs from "@/components/site/WhyChooseUs";
import CTABand from "@/components/site/CTABand";
import SEO from "@/components/site/SEO";

export default function WhyUsPage() {
  return (
    <PageLayout testid="why-us-page">
      <SEO
        title="Why Choose Sudeeksha Invisible Grills Hyderabad"
        description="Rust-free SS316 steel, professional installation and written warranty. See why Hyderabad families trust Sudeeksha Invisible Grills for balcony and window safety."
        path="/why-us"
      />
      <PageHeader
        eyebrow="The Sudeeksha difference"
        title={["Why Choose", "Us"]}
        crumb="Why Us"
        subtitle="Rust-free SS316 steel, professional installation and warranty support — the reasons families across Hyderabad trust us with their safety."
      />
      <WhyChooseUs />
      <CTABand />
    </PageLayout>
  );
}
